<script>
import AnnouncementsApi from "@/services/announcements-api";
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import carousel from 'vue-owl-carousel'
// import simplebar from "simplebar-vue";

export default {

    props: {
      
      propDisplayTitle: {
          type:Boolean,
          default:true
        },

      propWhiteBackground: {
          type:Boolean,
          default:true
        },

      propFullwidth: {
          type:Boolean,
          default:false
        },

    },

    components: {
      carousel/*, simplebar*/
    },
    data () {
        return {
          highlightsList:[],

        }

    },
    mounted () {
     this.getPromotionsAndNews();
  },

methods: {

  getPromotionsAndNews() {
        AnnouncementsApi.getPromotionsAndNews(1, 100)
            .then(result => {
              if(result){
                this.highlightsList=result.list;
              }
            })
      },

},

  watch: {
   

    },
  };


</script>

<style>

#high-carousel img {
  width: 100%;
  height: 200px; /* replace with your desired height */
  object-fit: cover;
}

/* #high-carousel  p {
  display: -webkit-box;
  -webkit-line-clamp: 4; 
  -webkit-box-orient: vertical;
  overflow: hidden;
} */

/* #high-carousel  p::-webkit-scrollbar {
  width: 5px; 
}

#high-carousel  p::-webkit-scrollbar-track {
  background-color: #f1f1f1; 
}

#high-carousel  p::-webkit-scrollbar-thumb {
  background-color: #888; 
  border-radius: 5px; 
}

#high-carousel  p::-webkit-scrollbar-thumb:hover {
  background-color: #555; 
} */


#high-carousel p {
  padding-right: 10px; 
}

#high-carousel p::-webkit-scrollbar {
  width: 5px; /* replace with your desired scrollbar width */
}

#high-carousel p::-webkit-scrollbar-track {
  background-color: #f1f1f1; /* replace with your desired track color */
}

#high-carousel p::-webkit-scrollbar-thumb {
  background-color: #888; /* replace with your desired thumb color */
  border-radius: 5px; /* replace with your desired thumb border radius */
}

#high-carousel p::-webkit-scrollbar-thumb:hover {
  background-color: #555; /* replace with your desired hover thumb color */
}

#annoucement-title-small {
  
  box-sizing: border-box;
    font-family: "Open Sans", mm-main, arial, sans-serif;
    letter-spacing: normal;
    font-weight: 600;
    width: 100%;
    max-width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 14px;
    text-align: left;
    animation: 0s ease 0s 1 normal none running none !important;
    -webkit-line-clamp: 2;
    margin-top: 0px;
    line-height: 18px;
    height: 36px;
}

</style>

<template>


<div class="row pt-4 pb-4 p-4 p-lg-0 pt-lg-4 pb-lg-4" v-if="highlightsList.length > 0" style="border-radius:8px;" :class="propWhiteBackground ? 'bg-white' : ''">
  <!-- <div class="col-2 pb-0 pt-0 pb-lg-4 pt-lg-4"></div> -->
  <div class="col-12 pb-0 pt-0 pb-lg-4 pt-lg-4">

        <div v-if="propDisplayTitle" class="row pb-4" :class="propFullwidth ? '' : 'home-page-80-width'">
            <div class="col-12 text-left">
              <h2 class="text-dark font-weight-bold">
                <div class="row ">

                    <div class="col-12 text-primary text-center">

                      Notre Activité
                    </div>

                    <!-- <div class="col-2 text-right">

                        <a href="javascript:void(0);" @click="$refs.hightlightprev.click();" class="mr-2">
                            <i class="fas fa-angle-left text-dark font-size-20" ></i>
                        </a>

                        <a href="javascript:void(0);" @click="$refs.hightlightnext.click();">
                            <i class="fas fa-angle-right text-dark font-size-20" ></i>
                        </a>
                    </div> -->

                </div>
              </h2>
              <h5 class="text-success font-weight-bold text-center">Découvrez nos activités et nouveaux projets</h5>
            </div>
        </div>

          <div class="row mt-4 mb-2" :class="propFullwidth ? '' : 'home-page-80-width'">
            <div class="col-12">


              <carousel id="high-carousel" v-if="highlightsList.length > 0" :smartSpeed="2000" :autoplay="false" :autoplayHoverPause="true" :nav="false"  :dots="true"  :loop="false" 
                :items="2"  :responsive="{0:{items:1}, 576:{items:2}, 768:{items:2}, 992: {items:2}, 1200: {items:4}, 1400: {items:4}}"
                 :margin="50">

                  <template slot="prev"><span hidden ref="hightlightprev" class="prev">prev</span></template>
                  <template slot="next"><span hidden  ref="hightlightnext" class="next">next</span></template>

                  <div  class="row" v-for="(announcement) in this.highlightsList" :key="announcement.id">
           
                        <div class="col-12 pl-1">

                            <!-- src="@/assets/images/small-banner-1.jpeg" -->
                            <img  :src="'/api/image/get/' + announcement.image" >

                              <!-- <img  :src="'/api/image/get/' + announcement.image"   
                                style="border: 1px solid #ecedf0;box-shadow: rgb(0 0 0 / 57%) 0px 2px 6px 0px; border-radius:7px;" > -->
                        </div>
                            
                        <div id="annoucement-title-small" v-if="propDisplayTitle" class="col-12 mt-3 pl-1">
                          <h5 :title="announcement.title" class="text-primary mb-0 pb-0 text-left text-uppercase font-weight-bold">{{announcement.title}} </h5>
                        </div>

                        <div v-if="propDisplayTitle" class="col-12 mt-2 pl-1">
                          <!-- <simplebar style="max-height: 7em; min-height:7em" class="mt-2 w-100">  -->

                            <p  v-html="announcement.description"  style="max-height:100px; min-height:100px; overflow:auto;"
                                class="text-justify  font-size-14 pt-0"> </p>
                          <!-- </simplebar> -->
                        </div>


                        <div v-if="propDisplayTitle" class="col-6 mt-2 pt-1 pl-1 font-weight-bold text-left ">
                          <i class="bx bx-calendar me-1"></i> {{announcement.date}}
                        </div>

                        <!-- <div v-if="propDisplayTitle" class="col-6 mt-2 pt-1 pl-1 text-right">
                          <span v-if="announcement.tag" class="badge bg-secondary text-white ">
                            <strong>{{announcement.tag}}</strong> 
                          </span>
                        </div> -->


                        

                          

                       

                        
                  </div>


             </carousel>




            </div>
          </div>
      </div>
    </div>



    





</template>                 
               